import React, { useState } from "react";
import AdIframeTs from "@Components/ad/adIframeTs";
import { ArrowRightIcon, RightFillIcon } from "@t8891/icon";
import { Button } from "@t8891/pc";
import { IKindsPcInfo } from "@Types/kindsum";
import { formatThousend } from "../../utils/helper";
import { useQuery } from "react-query";
import { fetchSaleLeadsAgentDiscounts } from "@Services/api";
import { host } from "@Services/url";
import { setUrlFormat } from "@Lib/common";
import AskPriceModal from "@Components/buyCar/AskPriceModal";
import { useAtom } from "jotai";
import { activityAtom } from "@Lib/jotai/activity";
import KindSumRightDiscount from "./KindSumRightDiscount";
import AdIframeImage from "@Components/ad/AdFrame_v2";

const AdItem: React.FC<any> = ({ data }) => {
  return (
    <>
      {!!data.link && (
        <a href={data.link} target='_blank'>
          <img className='w-260 h-28 mt-14' src={data.image} />
        </a>
      )}
    </>
  );
};

const OneItem: React.FC<{ data: IKindsPcInfo }> = ({ data }) => {
  const { price, tax, saleCount, kindId, brandId, saleStop, usedCarLink, inquiry, saleMonth, willSale, rosterRelated, brandName, kindName } =
    data;
  return (
    <div id='OneItem' className='w-280 bg-white rounded-4 text-black px-10 relative pt-12 pb-12 mb-10'>
      {!!willSale && (
        <div
          className='w-28 text-12 text-primary flex items-center justify-center absolute right-0 top-0 rounded-4'
          style={{ border: "1px solid #3264ff" }}
        >
          預售
        </div>
      )}
      <div className='flex gap-10 text-14 items-center mt-4'>
        原廠建議售價 <div className='text-20 text-[#FF4433] w-160'>{price || "暫無報價"}</div>
      </div>
      <div
        className={`flex justify-between items-center mt-14 ${!!tax.tax && tax.tax.includes("-") && saleStop !== 1 ? "text-12" : "text-14"
          }`}
      >
        <div className='text-black flex gap-4 justify-center items-center'>
          <div className='text-[#999]'>稅金</div>
          {!!tax.tax && saleStop !== 1 ? (
            <div className='min-w-10'>{tax.tax}元</div>
          ) : (
            <span className='text-black'>--</span>
          )}
        </div>
        <div className='text-black flex gap-4 w-auto whitespace-pre pr-2'>
          <div className='text-[#999]'>{saleMonth}月銷量</div>
          {!!saleCount ? (
            <div className='min-w-10'>{`${formatThousend(saleCount)}輛`}</div>
          ) : (
            <span className='text-black'>--</span>
          )}
        </div>
      </div>

      {!!inquiry.isInquiry && (
        <div className='mt-14'>
          <KindSumRightDiscount data={data} />
          <div className="flex gap-10">
            <div
              id="tracking-InquiryBookDrive"
              data-id={kindId}
              className="h-66 border-1 border-[#3264ff] border-solid bg-[#EBF0FF] flex w-[124px] text-[#3264FF] text-20 justify-center cursor-pointer items-center rounded-8"
              onClick={() => {
                window.open(`/ask/price?b=${brandId}&k=${kindId}&source=綜述頁-預約試駕&kindType=bookDrive`, "_blank");
              }}
            >
              預約試駕
            </div>
            <Button
              type='danger'
              round={false}
              description={
                <span className='text-12 font-normal' dangerouslySetInnerHTML={{ __html: inquiry.inquiryMessage }} />
              }
              size='huge'
              block
              style={{ "--background-color": "#FF4333", "--height": "66px", "--width": "124px", borderRadius: "8px", paddingTop: "4px" }}
              onClick={() => {
                window.open(`/ask/price?b=${brandId}&k=${kindId}&source=綜述頁（新）-一鍵詢價`, "_blank");
              }}
            >
              {inquiry.inquiryTitle}
            </Button>
          </div>
        </div>
      )}

      {!!rosterRelated?.link && (
        <Button
          className='mt-14'
          type='danger'
          round={false}
          size='huge'
          description={
            <span className='text-12 font-normal' dangerouslySetInnerHTML={{ __html: rosterRelated.message }} />
          }
          block
          style={{ "--background-color": "#FF4333", "--border-color": "#FF4333" }}
          onClick={() => {
            window.open(`${rosterRelated.link}`, "_blank");
          }}
        >
          {rosterRelated.button}
        </Button>
      )}

      {saleStop === 1 && inquiry.isInquiry === 0 && usedCarLink !== "" && !rosterRelated.link && (
        <Button
          className='mt-14'
          type='danger'
          round={false}
          size='huge'
          block
          style={{ "--background-color": "#F87F15", "--border-color": "#F87F15" }}
          onClick={() => {
            window.open(`${usedCarLink}`, "_blank");
          }}
        >
          中古車
        </Button>
      )}


      {saleStop === 0 && inquiry.isInquiry === 0 && !!inquiry.showroomNum &&
        <a
          id="tracking-BookDriveShowroom"
          data-id={kindId}
          href={`/${setUrlFormat(brandName)}/${setUrlFormat(kindName)}/showroom`}
          target='_blank'
          className="h-66 mt-16 border-1 border-[#3264ff] border-solid bg-[#EBF0FF] flex w-full text-[#3264FF] hover:text-[#3264FF] text-20 justify-center cursor-pointer items-center rounded-8">
          預約試駕
        </a>}

      <AdIframeTs
        slot={"/173427088/newcar-pc-summary-price-belowbanner"}
        size={[["fluid"], ["fluid"]]}
        target={["ab_test", "B"]}
      >
        <AdItem />
      </AdIframeTs>
    </div>
  );
};

const arr = ({ brandId, kindId }) => [
  {
    img: "https://photo.8891.com.tw/2024/06/19/1718782661315716.png",
    title: "分期購車",
    desc: "超低頭款",
    href: `/ask/price?b=${brandId}&k=${kindId}&source=綜述頁（新）-分期購車&kindType=installment`,
    style: {},
  },
  {
    img: "https://photo.8891.com.tw/2024/06/19/1718782661315551.png",
    title: "汽車保險",
    desc: "免費試算",
    href: `/ask/price?b=${brandId}&k=${kindId}&source=綜述頁（新）-汽車保險&kindType=insurance`,
    style: {
      borderLeft: "1px solid #e8e8e8b3",
    },
  },
  {
    img: "https://photo.8891.com.tw/2024/06/19/1718782661370523.png",
    title: "現車查詢",
    desc: "避免等待",
    href: `/ask/price?b=${brandId}&k=${kindId}&source=綜述頁（新）-現車查詢&kindType=currentCar`,
    style: {
      borderTop: "1px solid #e8e8e8b3",
      borderBottom: "1px solid #e8e8e8b3",
    },
  },
  {
    img: "https://photo.8891.com.tw/2024/06/19/1718782661323778.png",
    title: "汰舊換新",
    desc: "再減5萬",
    href: `/ask/price?b=${brandId}&k=${kindId}&source=綜述頁（新）-汰舊換新&kindType=tradeIn`,
    style: {
      borderLeft: "1px solid #e8e8e8b3",
      borderTop: "1px solid #e8e8e8b3",
      borderBottom: "1px solid #e8e8e8b3",
    },
  },
  {
    img: "https://photo.8891.com.tw/2024/06/19/1718782661325649.png",
    title: "查成交價",
    desc: "真實用戶反饋",
    href: `/ask/price?b=${brandId}&k=${kindId}&source=綜述頁（新）-查成交價&kindType=checkPrice`,
    style: {
    },
  },
  {
    img: "https://photo.8891.com.tw/2025/02/14/1739525106077273.png",
    title: "高價收車",
    desc: "閃電成交",
    href: `${host.auto}/sell-spread.html?source=8891&entry=nc_op_hp_fm_hcp`,
    style: {
      borderLeft: "1px solid #e8e8e8b3",
    },
  },
];

const TwoItem: React.FC<any> = ({ item }) => {
  const { img, href, title, desc, style } = item;
  return (
    <a
      href={href}
      target='_blank'
      className={`w-140 h-64 bg-white  text-black px-10 relative pb-4 flex justify-between cursor-pointer items-center`}
      style={style}
    >
      <div className='flex items-center mt-4'>
        <img className='w-28 h-28' src={img} />
      </div>
      <div className=''>
        <div className='text-14 text-black mt-6'>{title}</div>
        <div className='text-12 text-[#999999] mt-4'>{desc}</div>
      </div>
      <div className='flex items-center'>
        <ArrowRightIcon size={40} fill={"#999"} />
      </div>
    </a>
  );
};

const ThreeItem: React.FC<{ data: IKindsPcInfo }> = ({ data }) => {
  const [visible, setVisible] = useState(false);
  const [activityInfo] = useAtom(activityAtom);

  const { kindId, brandName, kindName, brandId, saleStop, inquiry, usedCarLink } = data;
  const initData = {
    list: [],
  };
  const { data: disCount = initData, status } = useQuery<any>(
    [`fetchSaleLeadsAgentDiscounts`, kindId],
    async () => {
      const res = await fetchSaleLeadsAgentDiscounts({ k: `${kindId}`, limit: 1 });
      return res?.status === 12000 ? res.data : initData;
    },
    {
      enabled: !!kindId,
    },
  );

  return (
    <>
      {/* 無詢價，在售車款：不動，維持原有（不動估車banner） */}
      {saleStop === 0 && inquiry.isInquiry === 0 && (
        <>
          {disCount?.list.length === 0 && status === "success" && (
            <div className='w-280 h-72 rounded-4 bg-[#eff1f6] mb-10'>
              <AdIframeTs slot={"/173427088/newcar-pc-summary-car-right"} size={[["fluid"], ["fluid"]]}>
                <AdFooterItem />
              </AdIframeTs>
            </div>
          )}
        </>
      )}
      {/* {disCount?.list.length > 0 && (
        <>
          <AskPriceModal
            visible={visible}
            setVisible={setVisible}
            brandId={brandId}
            data={{
              ...disCount?.list[0],
              regionId: disCount?.list[0]?.agent.showroom.regionId,
            }}
            source={"綜述頁（新）-領取優惠"}
            kindId={kindId}
          />

          <div id={"ThreeItem"} className='bg-white text-black text-14 rounded-4 w-280 py-4 h-72 overflow-hidden'>
            <div className='flex justify-between w-full px-10'>
              <div className='flex gap-4 items-center'>
                <div className=''>優惠禮包</div>
                {activityInfo?.activityStatus === 1 && (
                  <i
                    className='text-12 text-white w-126 h-18  flex items-center justify-center bg-cover no-repeat font-[400] pt-2'
                    style={{
                      backgroundImage: `url("https://photo.8891.com.tw/2024/06/19/1718787727520077.png")`,
                      WebkitBackgroundSize: "100% 100%",
                    }}
                  >
                    {disCount.list[0].type === "roster" ? "廠牌優惠" : "廠牌優惠+8891補貼"}
                  </i>
                )}
              </div>
              <a
                href={`/${brandName}/${setUrlFormat(kindName)}/discount.html`}
                target='_blank'
                className='flex items-center text-[#999] text-12 mr-4'
              >
                更多
                <RightFillIcon size={32} fill='#333' />
              </a>
            </div>

            <div
              className='w-full h-44 relative flex justify-between items-center mt-6 pt-6'
              style={{ background: `linear-gradient(360deg,#ffffff, #fefeff 0%, #f0f4fe)` }}
            >
              {disCount.list.length > 0 && (
                <div className='text-12 ml-10'>
                  {disCount.list[0].type === "roster"
                    ? `${disCount.list[0].showContent}`
                    : `${disCount.list[0].packageValue}優惠禮包，${disCount.list[0].agent.showroom.regionName}業代提供`}
                </div>
              )}

              <div className='w-56 h-24 bg-white mr-10 z-1 text-12'>
                <Button
                  type='primary'
                  size='mini'
                  fill='outline'
                  round={false}
                  onClick={() => {
                    if (disCount.list[0].type === "roster") {
                      window.open(`/ask/price?b=${brandId}&k=${kindId}&source=綜述-領優惠`, "_blank");
                      return;
                    }
                    setVisible(true);
                  }}
                  style={{
                    "--width": "56px",
                    padding: 0,
                    "--background-color": "#fff",
                  }}
                >
                  領優惠
                </Button>
              </div>
              <i
                className='w-66 h-44 bg-cover no-repeat absolute right-0 bottom-0'
                style={{ backgroundImage: `url(https://photo.8891.com.tw/2024/06/19/1718787722489191.png)` }}
              />
            </div>
          </div>
        </>
      )} */}
    </>
  );
};

const AdFooterItem: React.FC<any> = ({ data }) => {
  const { link, image } = data;
  return (
    <>
      {!!image && (
        <a href={link} target='_blank'>
          <img className='w-280 h-72 rounded-4' src={image} />
        </a>
      )}
    </>
  );
};

const KindSumRightInquiry: React.FC<{ data: IKindsPcInfo }> = ({ data }) => {
  const { kindId, brandId, inquiry } = data;

  return (
    <div id={"KindSumRightInquiry"} className='z-1'>
      <OneItem data={data} />

      {inquiry.isInquiry === 1 && (
        <div className='w-280 h-200 bg-white flex flex-wrap justify-center mb-10  rounded-6 overflow-hidden relative'>
          {arr({ kindId, brandId }).map((item: any, index: number) => (
            <TwoItem item={item} key={index} />
          ))}
        </div>
      )}

      {data.saleStop === 0 && inquiry.isInquiry === 0 && inquiry.showroomNum === 0 && <ThreeItem data={data} />}


      {inquiry.isInquiry === 0 && (
        <div className='relative'>
          <AdIframeImage
            slot={"/173427088/newcar-pc-summary-right-top"}
            size={[["fluid"], ["fluid"]]}
            width={280}
            height={280}
            styles={{ width: 280, height: 280, marginTop: "42px" }}
          />
        </div>
      )}
    </div>
  );
};

export default KindSumRightInquiry;
